var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookingForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2199_19062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7862 1V18.6L8.44138 16.7C8.33103 16.65 8.22069 16.65 8.11034 16.65C8 16.65 7.88966 16.65 7.77931 16.7L1.26896 18.6V1H14.7862ZM15.8897 0H0.110352V20L8.05517 17.7L15.8897 20V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47591 6.3H1.26901C0.937975 6.3 0.717285 6.1 0.717285 5.8C0.717285 5.5 0.937975 5.3 1.26901 5.3H3.47591C3.80694 5.3 4.02763 5.5 4.02763 5.8C4.02763 6.1 3.75177 6.3 3.47591 6.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65505 6.3H6.5654C6.23436 6.3 6.01367 6.1 6.01367 5.8C6.01367 5.5 6.23436 5.3 6.5654 5.3H9.65505C9.98609 5.3 10.2068 5.5 10.2068 5.8C10.2068 6.05 9.98609 6.3 9.65505 6.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0069 6.3H12.8C12.469 6.3 12.2483 6.1 12.2483 5.8C12.2483 5.5 12.469 5.3 12.8 5.3H15.0069C15.3379 5.3 15.5586 5.5 15.5586 5.8C15.5586 6.1 15.2828 6.3 15.0069 6.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28275 14.9C7.06206 14.9 6.89654 14.85 6.73102 14.7L4.08275 12.45C3.86206 12.25 3.86206 11.95 4.08275 11.75C4.30344 11.55 4.63447 11.55 4.85516 11.75L7.22758 13.8L11.3655 8.6C11.531 8.4 11.8621 8.3 12.1379 8.5C12.3586 8.65 12.469 8.95 12.2483 9.2L7.94482 14.65C7.7793 14.8 7.61378 14.95 7.33792 14.95C7.33792 14.9 7.33792 14.9 7.28275 14.9Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2199_19062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingForm);
export default __webpack_public_path__ + "static/media/booking-form.7262eeada61b27a8cc77a2f179fca3e5.svg";
export { ForwardRef as ReactComponent };